//////////////////////////////////////////////////////////////////////////////
//
//  User Agreement API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-30
//
//  설명: 사용자 동의 현황 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 사용자 동의 현황 관련 API
 */
const UserAgreementAPI: ApiGroup = {
    pagedList: {
        title: "사용자 동의 현황 조회",
        url: "/UserTermsAgreement/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 사용자 동의 목록 조회",
        url: "/UserTermsAgreement/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "사용자 동의 상세 조회",
        url: "/UserTermsAgreement/{id}",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    getByUserId: {
        title: "특정 사용자 동의 이력 조회",
        url: "/UserTermsAgreement/User/{userId}",
        method: "GET",
        paramz: {},
        pathParams: ["userId"],
    },
}

export default UserAgreementAPI
